import Params from "./getParams";
import axios from 'axios';

const courseRequest = axios.create({
  baseURL: `${process.env.host}` + "/api",
});

// get
// export const getGymCourse = () => courseRequest.get(`/gym_courses?sgid=${Params.sgid}`);
export const getGymCourse = (data) => courseRequest.get(`/gym_courses`,data);
export const getFunctionCourse = (data) => courseRequest.get(`/function_courses`,data);
export const getGymClosed = (data) => courseRequest.get(`/gym_closed_dates`,data);
export const getFunctionClosed = (data) => courseRequest.get(`/function_closed_dates`,data);
export const getAdminClosed = (data) => courseRequest.get(`/admin_closed_dates`,data);
export const getSelectedGym = (data) => courseRequest.get(`/selected_gym_courses?sgid=${Params.sgid}`);
export const getSelectedFun = () => courseRequest.get(`/selected_function_courses?sgid=${Params.sgid}`);
export const getCourseAdmin = (data) => courseRequest.get(`/admin_courses`,data);

export const getStudents = () => courseRequest.get(`/get_students?sgid=${Params.sgid}`);

//post
export const userRegisterCourse = (data) => courseRequest.post("/select_course", data);
